// import {
//   Component,
//   Input,
//   OnInit,
//   Renderer2,
//   ViewChild,
//   ChangeDetectorRef,
// } from "@angular/core";
// import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
// import { CommonService } from "../services/common.service";
// import { DomSanitizer } from "@angular/platform-browser";
// import { environment } from "../../environments/environment";
// import { SidebarStateService } from "../services/sidebar-state.service";
// import { ToastrService } from "ngx-toastr";
// import { MenuService } from "../services/menu.service";
// import { filter } from "rxjs/operators";
// import { MultiSelectComponent } from "ng-multiselect-dropdown";
// import { HttpClient } from "@angular/common/http";
// const url = environment.fileUrl;
// // declare var onloadfn: any;
// // declare var loadCr: any;
// declare var $: any;
// @Component({
//   selector: "app-sidebar",
//   templateUrl: "./sidebar.component.html",
//   styleUrls: ["./sidebar.component.css"],
// })
// export class SidebarComponent implements OnInit {
//   @ViewChild("dropdown", { static: false }) dropdown: MultiSelectComponent;
//   roleId: any = localStorage.getItem("RoleId") || 3;
//   tenantCode: any = localStorage.getItem("TenantCode");
//   roleName: any = localStorage.getItem("RoleName");
//   applicantId = localStorage.getItem("IsApplicant");
//   isApplicant: any;
//   menus: Array<any> = []; menusShow: boolean = false;
//   clientLogo: any;
//   isLogo: boolean = false;
//   url: any;
//   selectedMenuItem: any = "Dashboard"; // Initialize with 'Dashboard' or the default active item
//   lastSelectedMenuItem: any = null; // Initialize as null
//   isShow: any = localStorage.getItem("UserBaseSidebarMenu");
//   isSubmit: any = localStorage.getItem("isStudent");
//   isExpanded: boolean;
//   currentMenu: any;
//   allChilds: any[] = [];
//   dropdownSettings: any = {};
//   selectedMenu: any = [];

//   base64Image = `data:image/png;base64,${localStorage.tnt_logo}`;
//   @Input() sMaduleId: any = 1;
//   desiredUrl: any;

//   constructor(
//     private renderer: Renderer2,
//     private cdr: ChangeDetectorRef,
//     private route: ActivatedRoute,
//     private router: Router,
//     private service: CommonService,
//     private sanitizer: DomSanitizer,
//     private sidebarStateService: SidebarStateService,
//     private toastr: ToastrService,
//     private menuService: MenuService,
//     private http: HttpClient
//   ) {
//     this.loadScript();
//     // this.getMenu();

//     this.sidebarStateService.isExpanded$.subscribe((isExpanded) => {
//       this.isExpanded = isExpanded;
//     });

//     // this.roleId = atob(this.roleId);
//     this.service.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
//       this.roleId = value;
//     })
//     this.isApplicant =
//       (this.roleId == "3" || this.roleId == 3) && this.applicantId === "1";
//     this.isShow =
//       this.roleId == "3" || this.roleId == 3
//         ? localStorage.getItem("UserBaseSidebarMenu")
//         :  'true';

//     if (localStorage.getItem("Logo") == "") {
//       this.isLogo = true;
//     } else {
//       this.isLogo = false;
//     }
//   }
//   ngOnChanges(changes: any): void {
//     if (+changes.sMaduleId.currentValue) {
//       this.getMenu();
//       // let roleID: any = atob(localStorage.getItem("RoleId")!);
//       let roleID: any = '';
//       this.service.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
//         roleID = value;
//       });
//       if (
//         (roleID == "3" || roleID == "1" || roleID == "2") &&
//         this.applicantId != "1"
//       ) {
//         this.getMoodleUrl();
//       }

//       // this.getMoodleUrl();
//     }
//     this.dropdownSettings = {
//       singleSelection: true,
//       idField: "path",
//       textField: "Name",
//       selectAllText: "Select All",
//       unSelectAllText: "UnSelect All",
//       itemsShowLimit: 1,
//       allowSearchFilter: true,
//       enableCheckAll: false,
//     };
//   }
//   ngOnInit(): void {
//     this.url = window.location.pathname;
//     this.clientLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
//       `data:image/png;base64, ${localStorage.getItem("Logo")}`
//     );
//     if (this.sMaduleId !== 1) {
//       this.getMenu();
//       // let roleID: any = atob(localStorage.getItem("RoleId")!);
//       let roleID: any = '';
//       this.service.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
//         roleID = value;
//       })
//       if (
//         (roleID == "3" || roleID == "1" || roleID == "2") &&
//         this.applicantId != "1"
//       ) {
//         this.getMoodleUrl();
//       }
//       this.sMaduleId = roleID;
//       // this.sMaduleId = localStorage.getItem("RoleId");
//     }
//   }
//   ngAfterViewInit(): void {
//     // The dropdown will be available here
//   }
//   getClass(name) {
//     return "mdi " + name + " menu-icon";
//   }
//   loadScript() {
//     const script = this.renderer.createElement("script");
//     script.src = "assets/plugins/metismenu/js/metisMenu.min.js";
//     script.async = true;
//     script.defer = true;
//     this.renderer.appendChild(document.body, script);
//   }
//   getMoodleUrl() {
//     let payload = {
//       WSTOKEN: localStorage.getItem("MoodleTkn"),
//       username: localStorage.getItem("MoodleUserName"),
//       COURSE_ID: 0,
//     };
//     this.service.activateSpinner();
//     this.service
//       .postCall("MoodleIntegration/GetMoodleRequestLoginURL", payload)
//       .subscribe(
//         (res: any) => {
//           let splitUrl = res?.LoginUrl?.split("&wantsurl=");
//           if (splitUrl && splitUrl.length > 0) {
//             this.desiredUrl = splitUrl[0];
//           }
//           this.service.deactivateSpinner();
//           // this.iframeUrl =
//           //   this.sanitizer.bypassSecurityTrustResourceUrl(desiredUrl);
//         },
//         (e) => {
//           this.toastr.error(
//             e.error.message == null ? "User doesn't exist on LMS" : ""
//           );
//           this.service.deactivateSpinner();
//         }
//       );
//   }
//   navigate(path: string, menu: any, event: Event) {
//     if (menu.Name == "LMS" || menu.Name == "SOMAS") {
//       // let url = window.location.origin;
//       window.open(this.desiredUrl);
//       event.preventDefault();
//       return;
//     }
//     if (menu.Name === "Dashboard") {
//       // Only set the last selected item if it's not the Dashboard
//       if (this.selectedMenuItem !== "Dashboard") {
//         this.lastSelectedMenuItem = this.selectedMenuItem;
//       }
//     } else {
//       this.selectedMenuItem = menu.Name;
//       localStorage.setItem("menuName", this.selectedMenuItem);
//       if (this.selectedMenuItem != "My Student Registration") {
//         sessionStorage.setItem("reloaded", "false");
//       }
//       // Handle navigation logic here

//       if (!menu.childs?.length && path) {
//         let url = this.url.replaceAll("/HOME/", "");

//         let findPath = JSON.stringify(this.menus).includes(path || url);
//         if (findPath) {
//           this.router.navigate(["HOME/" + path]);
//           this.closeLeftMenuforMobile();
//           return;
//         } else {
//           alert(12);
//         }
//       }
//     }
//   }

//   encodeLabel(name: string | null | undefined): string {
//     return name ? encodeURIComponent(name) : '';
//   }

//   navigateToDashboard() {
//     let dashboardRoute: any;

//     if (
//       this.roleId === "1"
//       //  ||
//       // this.roleId === "2123" ||
//       // this.roleId === "2124" ||
//       // this.roleId === "2092" ||
//       // this.roleId === "2093" ||
//       // this.roleId === "2127"
//     ) {
//       dashboardRoute = "/HOME/instituteDashboard";
//       // dashboardRoute = "/HOME/adminDashboard"; 
//     } else if (this.roleId === "2" || this.roleId === "Mg==") {
//       dashboardRoute = "/HOME/dashboard";
//     } else if (this.roleId === "3") {
//       dashboardRoute = "/HOME/studentDashboard";
//     } else if (this.roleId === "4") {
//       dashboardRoute = "/HOME/superAdminDashboard";
//     } else if(this.roleId == 2128){
//       dashboardRoute = "/HOME/cdeDashboard";
//     } else if(this.roleId == 2127){
//       dashboardRoute = "/HOME/scdeDashboard";
//     } else if(this.roleId == 2129){
//       dashboardRoute = "/HOME/qasoDashboard";
//     } else if(this.roleId == 10){
//       dashboardRoute = "/HOME/ictDashboard";
//     }else {
//       dashboardRoute = "/HOME/dashboard";
//     }

//     // Save menu selection
//     if (this.selectedMenuItem !== "Dashboard") {
//       this.lastSelectedMenuItem = this.selectedMenuItem;
//     }

//     this.selectedMenuItem = "Dashboard";
//     localStorage.setItem("menuName", this.selectedMenuItem);
//     sessionStorage.setItem("reloaded", "false");

//     // Navigate to resolved route
//     this.router.navigate([dashboardRoute]);

//     this.closeLeftMenuforMobile();
//   }

//   navigateToOuk() {
//     // window.open('https://ouk.ac.ke/')
//     this.router.navigate(["/HOME/dashboard"]);
//   }
//   updateCurrentMenu(url: string): void {
//     let currentUrl = url.replace("/HOME/", "");
//     this.currentMenu = this.findParentObject(this.menus, currentUrl);
//     // console.log(this.currentMenu,'current Menu',currentUrl);
//   }
//   findParentObject(menus: any, currentPath: any): any {
//     const paths = [
//       "registration/editUserRegistration",
//       "registration/profile",
//       "registration/editRegistrationForm",
//       "components/regForm",
//     ];
//     if (currentPath === "dashboard") {
//       return "Dashboard";
//     } else if (currentPath.includes("components/payment")) {
//       return "Fees Accounts";
//     } else if (paths.some((path) => currentPath.includes(path))) {
//       return "Personal Info";
//     } else if (currentPath === "components/prnlDetailsRegForm") {
//       return "Personal Details Registration";
//     } else if (currentPath === "myApplication") {
//       return "My Application";
//     }

//     for (const menu of menus) {
//       // Check if the current menu path matches the current path
//       if (menu.path === currentPath) {
//         return menu.Name;
//       }
//       if (menu.childs && menu.childs.length > 0) {
//         for (const child of menu.childs) {
//           if (child.path === currentPath) {
//             return menu.Name;
//           } else if (child.isParent && child.childs.length > 0) {
//             const result = this.findParentObject(child.childs, currentPath);
//             if (result) {
//               return menu.Name;
//             }
//           }
//         }
//       }
//     }
//     return null;
//   }

//   getMenu() {
//     let applicantId = localStorage.getItem("IsApplicant");
//     let payLoad = {
//       Roleid_base64string:
//         applicantId == "0" || applicantId == "2"
//           ? localStorage.getItem("RoleId")
//           : localStorage.getItem("ApplicantRoleId"),
//       USER_ID: parseInt(localStorage.getItem("UserId") as any),
//       TENANT_CODE: parseInt(localStorage.getItem("TenantCode") as any),
//     };

//     this.service.postCall("Account/LoadMenusByRoleId", payLoad).subscribe(
//       (res: any[]) => {
//         this.menus = res;
//         // let rId = atob(localStorage.getItem("RoleId")!);
//         let rId: any = '';
//         this.service.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
//           rId = value;
//         })
//         // let libraryMenu = {
//         //   Name: "Library",
//         //   path: "",
//         //   CssClass: "fas fa-book-open",
//         //   childs: [
//         //     {
//         //       Name: "KOHA OUK Library",
//         //       path: "http://elibrary.ouk.ac.ke:8080/",
//         //       target: "_blank",
//         //     },
//         //     {
//         //       Name: "OUK OPAC Library",
//         //       path: "https://elibrary.ouk.ac.ke/",
//         //       target: "_blank",
//         //     },
//         //     {
//         //       Name: "My LOFT OUK Library",
//         //       path: "https://admin.myloft.xyz",
//         //       target: "_blank",
//         //     },
//         //   ],
//         // };

//         // if (this.roleId == 1) {
//         //   this.menus.splice(this.menus.length - 1, 0, libraryMenu); // Insert at second-last
//         // } else if (this.roleId == 3) {
//         //   this.menus.splice(this.menus.length - 2, 0, libraryMenu); // Insert at third-last
//         // }

//         this.menus = [...this.menus];
//         this.menuService.setMenus(this.menus);
//         let currentURL = window.location.pathname;
//         this.allChilds = this.getAllChilds(this.menus);
//         if (rId == "2") {
//           return this.router.navigate(["/HOME/dashboard"]);
//         } else {
//           this.updateCurrentMenu(currentURL);
//           this.router.events
//             .pipe(filter((event) => event instanceof NavigationEnd))
//             .subscribe((event: NavigationEnd) => {
//               if (event.urlAfterRedirects.includes("HOME")) {
//                 this.updateCurrentMenu(event.urlAfterRedirects);
//               }
//             });
//         }

//         // setTimeout(() => {
//         //   if (onloadfn) {
//         //     onloadfn();
//         //   }
//         //   if (loadCr) {
//         //     loadCr();
//         //   }
//         // }, 100)
//         return;
//         let isSubmitbool: any = localStorage.getItem("isStudent");
//         let roleId: any = atob(this.roleId);
//         // Check if 'isSubmitbool' is not null or undefined and convert it to boolean
//         if (
//           isSubmitbool &&
//           isSubmitbool.toLowerCase() === "false" &&
//           roleId == 3
//         ) {
//           // Filter menu items to include only required items for students
//           this.menus = this.menus.filter((item) => {
//             return (
//               item.Name === "My Program" ||
//               item.Name === "My Application" ||
//               item.Name === "My Student Registration"
//             );
//           });
//         }
//         // Handle navigation or further processing of filtered menus here if needed
//       },
//       (err) => {
//         // Handle error
//       }
//     );
//   }

//   getId(id: any) {
//     return id.replaceAll(/\s/g, "");
//   }

//   closeLeftMenuforMobile () : void {
//       if (window.innerWidth <= 768) {
//     document.querySelector('.body-wrapper')?.classList.remove('toggled');
//   }
//     if (window.matchMedia("(max-width: 767px)").matches) {
//       const idClickEvent = document.getElementById("sidebar");
//       if (idClickEvent) {
//         idClickEvent.classList.value = "wrapper";
//       }
//     }
//   }
//   userGuide() {
//     const URL = `${url}home/KNA/Tvet-StudentRegistration-UserGuide.pdf`;
//     window.open(URL);
//   }
//   navigateToLibraryUrl(url: any) {
//     window.open(url);
//   }

//   flattenChilds(node: any): any[] {
//     let result: any[] = [];
//     if (node.childs && node.childs.length > 0) {
//       node.childs.forEach((child) => {
//         result.push(child);
//         result = result.concat(this.flattenChilds(child));
//       });
//     }
//     return result;
//   }

//   getAllChilds(data: any[]): any[] {
//     let allChilds: any[] = [];
//     data.forEach((item) => {
//       allChilds = allChilds.concat(this.flattenChilds(item));
//     });
//     return allChilds;
//   }

//   SearchMenuNav() {
//     $("#staticBackdrop").modal("show");
//   }

//   onItemSelect(item: any) {
//     if (item.path.split("/").length > 2) {
//       this.cdr.detectChanges();
//       this.router.navigate(["HOME/" + item.path]);
//       this.closeSearch();
//     } else {
//       this.toastr.warning(
//         "Screen not available for selected item please select another item"
//       );
//     }
//   }

//   onItemDeSelect(item: any) {}

//   closeSearch() {
//     $("#staticBackdrop").modal("hide");
//     this.selectedMenu = [];
//   }
//   mydocuments() {
//     this.router.navigate(["/HOME/misReports/myDocuments"]);
//   }

//   isUrlBasedLogo(): boolean {
//     const tntLogo: any = localStorage.getItem("tnt_logo");
//     return tntLogo?.length > 0 && tntLogo != "undefined";
//   }

//   loginInternship() {
//     this.service
//       .postCall("Enroll/CheckCourseRegisteredByUser", {
//         STUDENT_PAYMENT_STUDENT_ID: localStorage.getItem("UserId"),
//         TENANT_CODE: this.tenantCode,
//       })
//       .subscribe((res: any) => {
//         if (res.message) {
//           this.service.activateSpinner();
//           const data = JSON.parse(sessionStorage.userData);
//           let payload = {
//             title: 38,
//             firstname: data.FIRSTNAME,
//             lastname: data.LASTNAME,
//             mobileno: data.mobileno,
//             username: data.USERNAME,
//             dob: "2000-01-01",
//             Gender: 1,
//             TENANT_CODE: 58192556,
//             UserType: 26,
//             Role: 3,
//             Timezone: "India Standard Time",
//             CREATEDBY: data.USERID,
//             Company_id: "51",
//             RoleId: 26,
//             origin: sessionStorage.getItem("internshipUrl"),
//             internshipid: data.USERID,
//           };
//           const internUrl = sessionStorage.getItem("internshipUrl");
//           const apiUrl = `${internUrl}api/Registration/InternshipRegistration`;
//           this.http.post(apiUrl, payload).subscribe(
//             (res: any) => {
//               let loginData = {
//                 UserName: res.UserName,
//                 password: res.password,
//               };
//               const encodedData = btoa(JSON.stringify(loginData)); // Encode properly
//               window.open(`${internUrl}login?data=${encodedData}`, "_blank");
//               if (res.message === "Registration Successful" && res.status) {
//                 this.service
//                   .postCall("Registration/UpdateUserByInternshipId", {
//                     TenantCode: this.tenantCode,
//                     UserId: localStorage.getItem("UserId"),
//                     internship_userid: res?.userID,
//                   })
//                   .subscribe((res: any) => {});
//               }
//               this.service.deactivateSpinner();
//             },
//             (error) => {
//               console.error("Error:", error);
//               this.toastr.error("Something went wrong!");
//               this.service.deactivateSpinner();
//             }
//           );
//         } else {
//           return this.toastr.error("Please register for course");
//         }
//       });

//     // "https://oukinternship.dhanushinfotech.com/api/Registration/InternshipRegistration";
//   }
// }


// sidebar.component.ts (Updated)
import {
  Component,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  HostListener
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { CommonService } from "../services/common.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../environments/environment";
import { SidebarStateService } from "../services/sidebar-state.service";
import { ToastrService } from "ngx-toastr";
import { MenuService } from "../services/menu.service";
import { filter } from "rxjs/operators";
import { MultiSelectComponent } from "ng-multiselect-dropdown";
import { HttpClient } from "@angular/common/http";
import { FormDataPersistenceService } from "../services/form-data-persistence.service";

const url = environment.fileUrl;
declare var $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  @ViewChild("dropdown", { static: false }) dropdown:any= MultiSelectComponent;
  roleId: any = localStorage.getItem("RoleId") || 3;
  tenantCode: any = localStorage.getItem("TenantCode");
  roleName: any = localStorage.getItem("RoleName");
  applicantId = localStorage.getItem("IsApplicant");
  isApplicant: any;
  menus: Array<any> = []; 
  menusShow: boolean = false;
  clientLogo: any;
  isLogo: boolean = false;
  url: any;
  selectedMenuItem: any = "Dashboard";
  lastSelectedMenuItem: any = null;
  isShow: any = localStorage.getItem("UserBaseSidebarMenu");
  isSubmit: any = localStorage.getItem("isStudent");
  isExpanded: boolean=true;
  currentMenu: any;
  allChilds: any[] = [];
  dropdownSettings: any = {};
  selectedMenu: any = [];

  base64Image = `data:image/png;base64,${localStorage.tnt_logo}`;
  @Input() sMaduleId: any = 1;
  desiredUrl: any;
  
  // Track if we're currently navigating
  private isNavigating = false;
  private pendingNavigation: { path: string; menu: any; event?: Event } | null = null;
  
  // Track which menu items are open (for click-toggle)
  openMenus: Set<any> = new Set();

  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private service: CommonService,
    private sanitizer: DomSanitizer,
    private sidebarStateService: SidebarStateService,
    private toastr: ToastrService,
    private menuService: MenuService,
    private http: HttpClient,
    private formPersistenceService: FormDataPersistenceService
  ) {
    this.loadScript();

    this.sidebarStateService.isExpanded$.subscribe((isExpanded) => {
      this.isExpanded = isExpanded;
    });

    this.service.decrypt$(localStorage.getItem("RoleId") || "0").subscribe(value => {
      this.roleId = value;
    });
    
    this.isApplicant = (this.roleId == "3" || this.roleId == 3) && this.applicantId === "1";
    this.isShow = this.roleId == "3" || this.roleId == 3 ? localStorage.getItem("UserBaseSidebarMenu") : 'true';

    if (localStorage.getItem("Logo") == "") {
      this.isLogo = true;
    } else {
      this.isLogo = false;
    }
    
    // Listen for navigation events to reset navigation flag
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.isNavigating = false;
      if (this.pendingNavigation) {
        // Execute pending navigation after a delay
        setTimeout(() => {
          this.executeNavigation(this.pendingNavigation!);
          this.pendingNavigation = null;
        }, 100);
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: any) {
    if (this.formPersistenceService.hasUnsavedData()) {
      event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
    }
  }

  ngOnChanges(changes: any): void {
    if (+changes.sMaduleId.currentValue) {
      this.getMenu();
      let roleID: any = '';
      this.service.decrypt$(localStorage.getItem("RoleId")|| "0").subscribe(value => {
        roleID = value;
      });
      if ((roleID == "3" || roleID == "1" || roleID == "2") && this.applicantId != "1") {
        this.getMoodleUrl();
      }
    }
    this.dropdownSettings = {
      singleSelection: true,
      idField: "path",
      textField: "Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }
  
  ngOnInit(): void {
    this.url = window.location.pathname;
    this.clientLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:image/png;base64, ${localStorage.getItem("Logo")}`
    );
    if (this.sMaduleId !== 1) {
      this.getMenu();
      let roleID: any = '';
      this.service.decrypt$(localStorage.getItem("RoleId") ||"").subscribe(value => {
        roleID = value;
      });
      if ((roleID == "3" || roleID == "1" || roleID == "2") && this.applicantId != "1") {
        this.getMoodleUrl();
      }
      this.sMaduleId = roleID;
    }
  }

  ngAfterViewInit(): void {
    // The dropdown will be available here
  }

  getClass(name:any) {
    return "mdi " + name + " menu-icon";
  }
  
  loadScript() {
    const script = this.renderer.createElement("script");
    script.src = "assets/plugins/metismenu/js/metisMenu.min.js";
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
  }
  
  getMoodleUrl() {
    let payload = {
      WSTOKEN: localStorage.getItem("MoodleTkn"),
      username: localStorage.getItem("MoodleUserName"),
      COURSE_ID: 0,
    };
    this.service.activateSpinner();
    this.service
      .postCall("MoodleIntegration/GetMoodleRequestLoginURL", payload)
      .subscribe(
        (res: any) => {
          let splitUrl = res?.LoginUrl?.split("&wantsurl=");
          if (splitUrl && splitUrl.length > 0) {
            this.desiredUrl = splitUrl[0];
          }
          this.service.deactivateSpinner();
        },
        (e) => {
          this.toastr.error(
            e.error.message == null ? "User doesn't exist on LMS" : ""
          );
          this.service.deactivateSpinner();
        }
      );
  }

  /**
   * Enhanced navigate method with form data persistence awareness
   */
  navigate(path: string, menu: any, event: Event) {
    // Prevent multiple navigation attempts
    if (this.isNavigating) {
      event?.preventDefault();
      return;
    }
    
    if (menu.Name == "LMS" || menu.Name == "SOMAS") {
      window.open(this.desiredUrl);
      event?.preventDefault();
      return;
    }
    
    // Check if there's unsaved form data
    if (this.formPersistenceService.hasUnsavedData()) {
      this.isNavigating = true;
      this.pendingNavigation = { path, menu, event };
      
      // Show confirmation dialog
      const confirmNavigation = confirm(
        "You have unsaved changes in the form. If you navigate away, your changes will be saved temporarily. Do you want to continue?"
      );
      
      if (confirmNavigation) {
        // Save form data before navigation (will be handled by the form component)
        // The form component's saveFormData method will be called via the canDeactivate guard
        this.executeNavigation({ path, menu, event });
      } else {
        // Cancel navigation
        this.isNavigating = false;
        this.pendingNavigation = null;
        event?.preventDefault();
      }
      return;
    }
    
    this.executeNavigation({ path, menu, event });
  }
  
  /**
   * Execute the actual navigation
   */
  private executeNavigation(navData: { path: string; menu: any; event?: Event }): void {
    const { path, menu, event } = navData;
    
    if (menu.Name === "Dashboard") {
      if (this.selectedMenuItem !== "Dashboard") {
        this.lastSelectedMenuItem = this.selectedMenuItem;
      }
    } else {
      this.selectedMenuItem = menu.Name;
      localStorage.setItem("menuName", this.selectedMenuItem);
      if (this.selectedMenuItem != "My Student Registration") {
        sessionStorage.setItem("reloaded", "false");
      }
      
      if (!menu.childs?.length && path) {
        let url = this.url.replaceAll("/HOME/", "");
        let findPath = JSON.stringify(this.menus).includes(path || url);
        if (findPath) {
          this.router.navigate(["HOME/" + path]);
          this.closeLeftMenuforMobile();
          return;
        }
      }
    }
  }

  encodeLabel(name: string | null | undefined): string {
    return name ? encodeURIComponent(name) : '';
  }

  /**
   * Enhanced navigateToDashboard with form data check
   */
  navigateToDashboard() {
    // Check for unsaved form data
    if (this.formPersistenceService.hasUnsavedData()) {
      const confirmNav = confirm(
        "You have unsaved changes in the form. If you navigate away, your changes will be saved temporarily. Do you want to continue?"
      );
      if (!confirmNav) {
        return;
      }
    }
    
    let dashboardRoute: any;

    if (this.roleId === "1") {
      dashboardRoute = "/HOME/instituteDashboard";
    } else if (this.roleId === "2" || this.roleId === "Mg==") {
      dashboardRoute = "/HOME/dashboard";
    } else if (this.roleId === "3") {
      dashboardRoute = "/HOME/studentDashboard";
    } else if (this.roleId === "4") {
      dashboardRoute = "/HOME/superAdminDashboard";
    } else if(this.roleId == 2128){
      dashboardRoute = "/HOME/cdeDashboard";
    } else if(this.roleId == 2145){
      dashboardRoute = "/HOME/rdeDashboard";
    } else if(this.roleId == 2127){
      dashboardRoute = "/HOME/scdeDashboard";
    } else if(this.roleId == 2129){
      dashboardRoute = "/HOME/qasoDashboard";
    } else if(this.roleId == 10){
      dashboardRoute = "/HOME/ictDashboard";
    } else {
      dashboardRoute = "/HOME/dashboard";
    }

    if (this.selectedMenuItem !== "Dashboard") {
      this.lastSelectedMenuItem = this.selectedMenuItem;
    }

    this.selectedMenuItem = "Dashboard";
    localStorage.setItem("menuName", this.selectedMenuItem);
    sessionStorage.setItem("reloaded", "false");

    this.router.navigate([dashboardRoute]);
    this.closeLeftMenuforMobile();
  }

  navigateToOuk() {
    this.router.navigate(["/HOME/dashboard"]);
  }
  
  updateCurrentMenu(url: string): void {
    let currentUrl = url.replace("/HOME/", "");
    this.currentMenu = this.findParentObject(this.menus, currentUrl);
  }
  
  findParentObject(menus: any, currentPath: any): any {
    const paths = [
      "registration/editUserRegistration",
      "registration/profile",
      "registration/editRegistrationForm",
      "components/regForm",
    ];
    if (currentPath === "dashboard") {
      return "Dashboard";
    } else if (currentPath.includes("components/payment")) {
      return "Fees Accounts";
    } else if (paths.some((path) => currentPath.includes(path))) {
      return "Personal Info";
    } else if (currentPath === "components/prnlDetailsRegForm") {
      return "Personal Details Registration";
    } else if (currentPath === "myApplication") {
      return "My Application";
    }

    for (const menu of menus) {
      if (menu.path === currentPath) {
        return menu.Name;
      }
      if (menu.childs && menu.childs.length > 0) {
        for (const child of menu.childs) {
          if (child.path === currentPath) {
            return menu.Name;
          } else if (child.isParent && child.childs.length > 0) {
            const result = this.findParentObject(child.childs, currentPath);
            if (result) {
              return menu.Name;
            }
          }
        }
      }
    }
    return null;
  }

  getMenu() {
    let applicantId = localStorage.getItem("IsApplicant");
    let payLoad = {
      Roleid_base64string:
        applicantId == "0" || applicantId == "2"
          ? localStorage.getItem("RoleId")
          : localStorage.getItem("ApplicantRoleId"),
      USER_ID: parseInt(localStorage.getItem("UserId") as any),
      TENANT_CODE: parseInt(localStorage.getItem("TenantCode") as any),
    };

    this.service.postCall("Account/LoadMenusByRoleId", payLoad).subscribe(
      (res: any[]) => {
        this.menus = res;
        let rId: any = '';
        this.service.decrypt$(localStorage.getItem("RoleId")|| "0").subscribe(value => {
          rId = value;
        });
        
        this.menus = [...this.menus];
        this.menuService.setMenus(this.menus);
        let currentURL = window.location.pathname;
        this.allChilds = this.getAllChilds(this.menus);
        
        if (rId == "2") {
          return this.router.navigate(["/HOME/dashboard"]);
        } else {
          this.updateCurrentMenu(currentURL);
          this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
              if (event.urlAfterRedirects.includes("HOME")) {
                this.updateCurrentMenu(event.urlAfterRedirects);
              }
            });
        }
      },
      (err) => {
        // Handle error
      }
    );
  }

  getId(id: any) {
    return id.replaceAll(/\s/g, "");
  }

  /** Click-toggle a menu item open/closed — accordion: closes others */
  toggleMenu(item: any, event: Event): void {
    event.stopPropagation();
    if (this.openMenus.has(item)) {
      this.openMenus.delete(item);
    } else {
      // Close all currently open top-level menus first
      this.openMenus.clear();
      this.openMenus.add(item);
    }
  }

  isMenuOpen(item: any): boolean {
    return this.openMenus.has(item);
  }

  closeLeftMenuforMobile(): void {
    if (window.innerWidth <= 768) {
      document.querySelector('.body-wrapper')?.classList.remove('toggled');
    }
    if (window.matchMedia("(max-width: 767px)").matches) {
      const idClickEvent = document.getElementById("sidebar");
      if (idClickEvent) {
        idClickEvent.classList.value = "wrapper";
      }
    }
  }
  
  userGuide() {
    const URL = `${url}home/KNA/Tvet-StudentRegistration-UserGuide.pdf`;
    window.open(URL);
  }
  
  navigateToLibraryUrl(url: any) {
    window.open(url);
  }

  flattenChilds(node: any): any[] {
    let result: any[] = [];
    if (node.childs && node.childs.length > 0) {
      node.childs.forEach((child:any) => {
        result.push(child);
        result = result.concat(this.flattenChilds(child));
      });
    }
    return result;
  }

  getAllChilds(data: any[]): any[] {
    let allChilds: any[] = [];
    data.forEach((item) => {
      allChilds = allChilds.concat(this.flattenChilds(item));
    });
    return allChilds;
  }

  SearchMenuNav() {
    $("#staticBackdrop").modal("show");
  }

  onItemSelect(item: any) {
    if (item.path.split("/").length > 2) {
      this.cdr.detectChanges();
      this.router.navigate(["HOME/" + item.path]);
      this.closeSearch();
    } else {
      this.toastr.warning(
        "Screen not available for selected item please select another item"
      );
    }
  }

  onItemDeSelect(item: any) {}

  closeSearch() {
    $("#staticBackdrop").modal("hide");
    this.selectedMenu = [];
  }
  
  mydocuments() {
    this.router.navigate(["/HOME/misReports/myDocuments"]);
  }

  isUrlBasedLogo(): boolean {
    const tntLogo: any = localStorage.getItem("tnt_logo");
    return tntLogo?.length > 0 && tntLogo != "undefined";
  }

  loginInternship() {
    this.service
      .postCall("Enroll/CheckCourseRegisteredByUser", {
        STUDENT_PAYMENT_STUDENT_ID: localStorage.getItem("UserId"),
        TENANT_CODE: this.tenantCode,
      })
      .subscribe((res: any) => {
        if (res.message) {
          this.service.activateSpinner();
          const data = JSON.parse(sessionStorage.userData);
          let payload = {
            title: 38,
            firstname: data.FIRSTNAME,
            lastname: data.LASTNAME,
            mobileno: data.mobileno,
            username: data.USERNAME,
            dob: "2000-01-01",
            Gender: 1,
            TENANT_CODE: 58192556,
            UserType: 26,
            Role: 3,
            Timezone: "India Standard Time",
            CREATEDBY: data.USERID,
            Company_id: "51",
            RoleId: 26,
            origin: sessionStorage.getItem("internshipUrl"),
            internshipid: data.USERID,
          };
          const internUrl = sessionStorage.getItem("internshipUrl");
          const apiUrl = `${internUrl}api/Registration/InternshipRegistration`;
          this.http.post(apiUrl, payload).subscribe(
            (res: any) => {
              let loginData = {
                UserName: res.UserName,
                password: res.password,
              };
              const encodedData = btoa(JSON.stringify(loginData));
              window.open(`${internUrl}login?data=${encodedData}`, "_blank");
              if (res.message === "Registration Successful" && res.status) {
                this.service
                  .postCall("Registration/UpdateUserByInternshipId", {
                    TenantCode: this.tenantCode,
                    UserId: localStorage.getItem("UserId"),
                    internship_userid: res?.userID,
                  })
                  .subscribe((res: any) => {});
              }
              this.service.deactivateSpinner();
            },
            (error) => {
              console.error("Error:", error);
              this.toastr.error("Something went wrong!");
              this.service.deactivateSpinner();
            }
          );
        } else {
          return this.toastr.error("Please register for course");
        }
      });
  }
}